import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import useDishes from "../hooks/useDishes";
import Box from "@mui/material/Box";
import { CardSolidGame } from "./CardSolidGame";
import Grid from "@mui/material/Grid2";

import usePageTitle from "../hooks/usePageTitle";

function DishList() {
  const { dishes, error, loading } = useDishes();

  usePageTitle("Dishes | Fudopia | Meet. Eat. Repeat.");

  return (
    <>
      {error && <p className="error-message">Something went wrong...</p>}
      <Typography variant="h1" component="div" sx={{ flexGrow: 0 }}>
        Dishes & Drinks
      </Typography>
      <div className="block-wrapper dishes grid">
        {loading && (
          <Grid container spacing={4} sx={{ justifyContent: "space-between" }}>
            {[...Array(10)].map((_, i) => (
              <Grid key={i}>
                <Skeleton
                  animation="wave"
                  height={500}
                  width="21vw"
                  sx={{ marginRight: 5 }}
                />
              </Grid>
            ))}
          </Grid>
        )}
        {!loading && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 2,
            }}
          >
            <CardSolidGame
              dishes={dishes}
              sx={{ justifyContent: "space-between" }}
            />
          </Box>
        )}
      </div>
    </>
  );
}

export default DishList;
